var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShieldTickFilled = function SvgShieldTickFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.95 15.204 16.254 9.9l-1.07-1.07-4.234 4.236-2.12-2.12-1.069 1.07zM12 21.48q-3.244-.885-5.372-3.82T4.5 11.102V5.345L12 2.54l7.5 2.807V11.1q0 3.627-2.128 6.562Q15.244 20.596 12 21.48"
  })));
};
export default SvgShieldTickFilled;